"use client"

import { BlockchainsMoleculeReatom } from "@/app/blockchains/blockchain-molecule.reatom"
import { canMakeItemOffer } from "@/app/nft/offer-dialog/can-make-item-offer"
import { ItemOfferDialog } from "@/app/nft/offer-dialog/item-offer-dialog.reatom"
import type { Nft } from "@anaconda/core/nft/types"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"

interface Props {
  nft: Nft
  className?: string
}

export const MakeOfferButton = reatomComponent<Props>(({ nft, className }) => {
  const { reatomIsEvmBlockchain, reatomWrappedCurrencyId } = useMolecule(
    BlockchainsMoleculeReatom,
  )
  const blockchain = nft.collection.blockchain

  // Renders nothing when the item cannot take an item bid, so callers can
  // drop it into a slot unconditionally.
  const canOffer = canMakeItemOffer(nft, {
    isEvm: reatomIsEvmBlockchain()(blockchain),
    hasWrappedCurrency: !!reatomWrappedCurrencyId()(blockchain),
  })
  if (!canOffer) return null

  return <ItemOfferDialog nft={nft} trigger={{ className }} />
}, "MakeOfferButton")
